import { render } from "./ShipmentAddressField.vue?vue&type=template&id=da26cc38"
import script from "./ShipmentAddressField.vue?vue&type=script&lang=js"
export * from "./ShipmentAddressField.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__